import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/lyft': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M0 81.1h77.8v208.7c0 33.1 15 52.8 27.2 61-12.7 11.1-51.2 20.9-80.2-2.8-17-14-24.8-37.3-24.8-59v-207.9zM485.9 254.6c0 14.2 11.6 25.9 26.1 25.9v76.5c-56.7 0-102.7-46.1-102.7-102.7v-77.1c0-34.6-52.2-34.6-52.2 0v23.3h38.8v76.8h-38.8v6.7c0 21.8-7.7 45-24.8 59-16.3 13.7-35.7 16.3-51.7 14v-179.2c0-56.7 46.1-102.7 102.7-102.7 49.1 0 90.2 34.4 100.3 80.7h26.1v76.8h-23.8v22zM191.6 155.6v-0.5h77.1v178.2c0 52.4-29.7 91.7-76.8 100.8-26.1 5.1-52.5 2.8-77.6-4.7v-70.3c9.8 4.2 29.5 9.4 45 7.8 20.4-2 32.8-11.9 34.9-25.3 0 0-21.2 20.4-58.2 10.6-37-9.9-45-40.1-45-63.9v-132.7h76.8v113c0 15.4 23.8 15.4 23.8 0v-113z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/lyft.js
// module id = 919
// module chunks = 0